// extracted by mini-css-extract-plugin
module.exports = {"container":"consent_container__HoVW9","textButton":"consent_textButton__X0K8C","disclaimer":"consent_disclaimer__6DGcZ"};